// extracted by mini-css-extract-plugin
module.exports = {"button":"style-module--button--2dnz7","secondary":"style-module--secondary--2g5PD","nowrap":"style-module--nowrap--39m0t"};